// extracted by css-extract-rspack-plugin
export default {"dangerButton":"UiDangerButton_dangerButton_fxY_G"};